<!-- The group heading and its fold live in the filter panel; this is the branch picker itself. -->
<div class="flex flex-col gap-1">
  <!-- What is actually filtering. Each pick is its own chip, so any one can be dropped. -->
  @if (facets().selection.length > 0) {
    <div
      class="flex flex-wrap items-center gap-1"
      [matTooltip]="'guaranteeV2.message.icd10SelectionHint' | translate"
    >
      @for (prefix of facets().selection; track prefix) {
        <button
          class="inline-flex items-center gap-0.5 rounded-full bg-primary-50 px-2 py-0.5 font-mono text-sm font-semibold text-primary-700 transition-colors duration-150 hover:bg-primary-100 focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:outline-none motion-reduce:transition-none"
          type="button"
          [matTooltip]="'guaranteeV2.message.removeIcd10Hint' | translate: { code: prefix }"
          (click)="prefixToggled.emit(prefix)"
        >
          {{ prefix }}
          <mat-icon class="h-3.5! w-3.5! text-sm! leading-3.5!">close</mat-icon>
        </button>
      }

      @if (facets().selection.length > 1) {
        <button
          class="inline-flex items-center gap-0.5 rounded-full px-1.5 py-0.5 text-sm font-medium text-neutral-500 transition-colors duration-150 hover:bg-neutral-100 focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:outline-none motion-reduce:transition-none"
          type="button"
          [attr.aria-label]="'guaranteeV2.action.clearIcd10Filter' | translate"
          [matTooltip]="'guaranteeV2.action.clearIcd10Filter' | translate"
          (click)="cleared.emit()"
        >
          <mat-icon class="h-3.5! w-3.5! text-sm! leading-3.5!">filter_alt_off</mat-icon>
        </button>
      }
    </div>
  }

  <!-- Breadcrumb walks the picker back up; it never changes what has been picked. -->
  @if (facets().cursor) {
    <div class="flex flex-wrap items-center gap-0.5">
      <button
        class="rounded-full px-1.5 py-0.5 text-sm font-medium text-neutral-500 transition-colors duration-150 hover:bg-neutral-100 focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:outline-none motion-reduce:transition-none"
        type="button"
        [matTooltip]="'guaranteeV2.message.icd10RootHint' | translate"
        (click)="cursorChanged.emit(null)"
      >
        {{ "guaranteeV2.label.allDiagnoses" | translate }}
      </button>

      @for (step of facets().breadcrumb; track step) {
        <mat-icon class="h-3.5! w-3.5! shrink-0 text-sm! leading-3.5! text-neutral-300">chevron_right</mat-icon>
        <button
          class="rounded-full px-1.5 py-0.5 font-mono text-sm font-semibold text-primary-600 transition-colors duration-150 hover:bg-primary-50 focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:outline-none motion-reduce:transition-none"
          type="button"
          [matTooltip]="'guaranteeV2.message.icd10StepUpHint' | translate: { code: step }"
          (click)="cursorChanged.emit(step)"
        >
          {{ step }}
        </button>
      }

      <mat-icon class="h-3.5! w-3.5! shrink-0 text-sm! leading-3.5! text-neutral-300">chevron_right</mat-icon>
      <span class="rounded-full bg-neutral-100 px-1.5 py-0.5 font-mono text-sm font-semibold text-neutral-700">{{ facets().cursor }}</span>
    </div>
  }

  <!-- Browsing does not filter, so picks accumulate across branches. -->
  <div class="flex max-h-56 flex-col gap-0.5 overflow-x-hidden overflow-y-auto">
    @for (node of facets().children; track node.prefix) {
      <div
        class="flex items-center rounded-lg transition-colors duration-150 hover:bg-neutral-50 motion-reduce:transition-none"
        [class]="node.selected ? 'bg-primary-50' : ''"
      >
        <button
          [class]="checkRow + ' flex-1'"
          type="button"
          [attr.aria-pressed]="node.selected"
          [matTooltip]="
            node.selected
              ? ('guaranteeV2.message.removeIcd10Hint' | translate: { code: node.prefix })
              : node.name
                ? ('guaranteeV2.message.icd10NodeNamedHint' | translate: { code: node.prefix, name: node.name, count: node.lineCount })
                : ('guaranteeV2.message.icd10NodeHint' | translate: { code: node.prefix, count: node.lineCount })
          "
          (click)="prefixToggled.emit(node.prefix)"
        >
          <guarantees-check-box [checked]="node.selected"></guarantees-check-box>
          <span class="shrink-0 font-mono font-semibold text-neutral-700">{{ node.prefix }}</span>
          @if (node.name) {
            <span class="min-w-0 flex-1 truncate text-neutral-500">{{ node.name }}</span>
          }
          <span class="ml-auto shrink-0 pl-1 text-neutral-400 tabular-nums">{{ node.lineCount }}</span>
        </button>

        @if (node.hasChildren) {
          <button
            class="inline-flex shrink-0 items-center rounded-lg px-1 py-1.5 transition-colors duration-150 hover:bg-neutral-100 focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:outline-none motion-reduce:transition-none"
            type="button"
            [attr.aria-label]="'guaranteeV2.message.icd10DrillHint' | translate: { code: node.prefix }"
            [matTooltip]="'guaranteeV2.message.icd10DrillHint' | translate: { code: node.prefix }"
            (click)="cursorChanged.emit(node.prefix)"
          >
            <mat-icon class="h-4! w-4! text-base! leading-4! text-neutral-400">chevron_right</mat-icon>
          </button>
        }
      </div>
    }
  </div>
</div>
